import React from "react";
import PropTypes from "prop-types";
import SucessMessage from "./SucessMessage";
import SucessMessage1xbet from "./SucessMessage1xbet";

function SucessMessageIndex({ is1xbet, ...props }) {
  return is1xbet ? (
    <SucessMessage1xbet {...props} />
  ) : (
    <SucessMessage {...props} />
  );
}

SucessMessageIndex.propTypes = {
  is1xbet: PropTypes.bool,
};

SucessMessageIndex.defaultProps = {
  is1xbet: false,
};

export default SucessMessageIndex;
